import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { imageUrl } from "../../Constants/contant";

function BlogFour({ blogs = [] }) {
  return (
    <section className="bg-smoke overflow-hidden space" id="blog-sec">
      <div className="container shape-mockup-wrap">
        <div className="mb-30 text-center text-md-start">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-7">
              <div className="title-area mb-md-0">
                {/* <span className="sub-title">News And Blog</span> */}
                <h2 className="sec-title">Tourm's Latest News and Insights</h2>
              </div>
            </div>
           
          </div>
        </div>

        {/* Swiper Slider */}
        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            768: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
          }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          className="th-slider has-shadow"
        >
          {blogs.map((d, i) => (
            <SwiperSlide key={i}>
              <div className="blog-  style2 th-ani">
                <div className="blog-img global-img">
                  <img
                    src={imageUrl + d?.image || "/assets/img/blog/blog_4_1.jpg"}
                    alt={d?.title || "blog"}
                  />
                </div>
                <div className="blog-box_content">
                  <div className="blog-meta">
                    <Link className="author" to="/blog">
                      {d?.date}
                    </Link>
                    {/* <Link to="/blog">6 min read</Link> */}
                  </div>
                  <h3 className="box-title">
                    <Link to='#'>{d?.title}</Link>
                  </h3>
                  <Link to={`/blog/${d?.id}`} className="th-btn style4 th-icon">
                    Read More
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Shapes */}
        <div
          className="shape-mockup spin d-none d-xxl-block"
          style={{ top: "0%", left: "-18%" }}
        >
          <img src="/assets/img/shape/shape_13.png" alt="shape" />
        </div>
        <div
          className="shape-mockup shape2 d-none d-xl-block"
          style={{ bottom: "5%", left: "-12%" }}
        >
          <img src="/assets/img/shape/shape_2.png" alt="shape" />
        </div>
        <div
          className="shape-mockup shape3 d-none d-xxl-block"
          style={{ bottom: "12%", left: "-17%" }}
        >
          <img src="/assets/img/shape/shape_3.png" alt="shape" />
        </div>
        <div
          className="shape-mockup movingX d-none d-xxl-block"
          style={{ top: "15%", right: "-15%" }}
        >
          <img src="/assets/img/shape/shape_14.png" alt="shape" />
        </div>
        <div
          className="shape-mockup d-none d-xxl-block"
          style={{ bottom: "-12%", right: "-21%" }}
        >
          <img src="/assets/img/shape/shape_15.png" alt="shape" />
        </div>
      </div>
    </section>
  );
}

export default BlogFour;
